export default {
  schema: {
    title: 'Screen Name',
    type: 'object',
    properties: {
      number: {
        title: 'Integer',
        type: 'integer'
      },
      double: {
        title: 'Double',
        type: 'number'
      },
      percent: {
        title: 'Percent',
        type: 'number'
      },
      currency: {
        title: 'Currency',
        type: 'number'
      },
      numberConstrained1: {
        title: 'Integer - between 5 and 10',
        type: 'integer',
        minimum: 5,
        maximum: 10
      },
      numberConstrained2: {
        title: 'Integer - under 100',
        type: 'integer',
        maximum: 99
      },
      numberConstrained3: {
        title: 'Integer - under 10000',
        type: 'integer',
        maximum: 9999
      },
      doubleConstrained: {
        title: 'Double - between 2.71 and 3.14',
        type: 'number',
        minimum: 2.71,
        maximum: 3.14
      },
      percentConstrained: {
        title: 'Percent - whole number between 0 and 100',
        type: 'integer',
        minimum: 0,
        maximum: 100
      },
      currencyConstrained: {
        title: 'Currency - between 0.25 and 100,000.25',
        type: 'number',
        minimum: 0.25,
        maximum: 100000.25
      },
      percentReadOnly: {
        title: 'Percent - read only',
        type: 'integer'
      },
      percentDisabled: {
        title: 'Percent - disabled',
        type: 'integer'
      },
      currencyReadOnly: {
        title: 'Currency - read only',
        type: 'number'
      },
      currencyDisabled: {
        title: 'Currency - disabled',
        type: 'number'
      },
      numberSuppressFormatting: {
        title: 'Integer - formatting suppressed',
        type: 'integer'
      },
      doubleSuppressFormatting: {
        title: 'Double - formatting suppressed',
        type: 'number'
      },
      arrayWithDecoratedFields: {
        type: 'array',
        title: 'DSA with Decorated Fields',
        minItems: 1,
        items: {
          type: 'object',
          properties: {
            id: {
              type: 'string',
              title: 'id'
            },
            percent: {
              title: 'Percent',
              type: 'number'
            },
            currency: {
              title: 'Currency',
              type: 'number'
            }
          }
        }
      }
    }
  },
  uiSchema: {
    standardNumericFieldsHeader: {
      'ui:title': {
        text: '<b>Standard Numeric Fields</b>',
        escape: false
      }
    },
    number: {
      'ui:widget': 'text'
    },
    double: {
      'ui:widget': 'text'
    },
    percent: {
      'ui:widget': 'text',
      'ui:options': {
        after: '%'
      }
    },
    currency: {
      'ui:widget': 'text',
      'ui:options': {
        before: '$',
        currency: 'USD'
      }
    },
    constrainedNumericFieldsHeader: {
      'ui:title': {
        text: '<b>Numeric Fields with Min/Max</b>',
        escape: false
      }
    },
    numberConstrained1: {
      'ui:widget': 'text'
    },
    numberConstrained2: {
      'ui:widget': 'text'
    },
    numberConstrained3: {
      'ui:widget': 'text'
    },
    doubleConstrained: {
      'ui:widget': 'text'
    },
    percentConstrained: {
      'ui:widget': 'text',
      'ui:options': {
        after: '%'
      }
    },
    currencyConstrained: {
      'ui:widget': 'text',
      'ui:options': {
        before: '$',
        currency: 'USD'
      }
    },
    restrictedNumericFieldsHeader: {
      'ui:title': {
        text: '<b>Restricted Numeric Fields</b>',
        escape: false
      }
    },
    percentReadOnly: {
      'ui:widget': 'text',
      'ui:readonly': true,
      'ui:options': {
        after: '%'
      }
    },
    percentDisabled: {
      'ui:widget': 'text',
      'ui:disabled': true,
      'ui:options': {
        after: '%'
      }
    },
    currencyReadOnly: {
      'ui:widget': 'text',
      'ui:readonly': true,
      'ui:options': {
        before: '$',
        currency: 'USD'
      }
    },
    currencyDisabled: {
      'ui:widget': 'text',
      'ui:disabled': true,
      'ui:options': {
        before: '$',
        currency: 'USD'
      }
    },
    suppressFormatNumericFieldsHeader: {
      'ui:title': {
        text: '<b>Numeric Fields with Formatting Suppressed</b>',
        escape: false
      }
    },
    numberSuppressFormatting: {
      'ui:widget': 'text',
      'ui:options': {
        suppressFormatting: true
      }
    },
    doubleSuppressFormatting: {
      'ui:widget': 'text',
      'ui:options': {
        suppressFormatting: true
      }
    },
    arrayWithDecoratedFields: {
      'ui:options': {
        itemName: 'Item'
      },
      items: {
        percent: {
          'ui:widget': 'text',
          'ui:options': {
            after: '%'
          }
        },
        currency: {
          'ui:widget': 'text',
          'ui:options': {
            before: '$',
            currency: 'USD'
          }
        },
        'dm:layout': [{
          type: 'field',
          id: 'percent'
        }, {
          type: 'field',
          id: 'currency'
        }]
      }
    },
    'dm:layout': [{
      type: 'text',
      id: 'standardNumericFieldsHeader'
    }, {
      type: 'field',
      id: 'number'
    }, {
      type: 'field',
      id: 'double'
    }, {
      type: 'field',
      id: 'percent'
    }, {
      type: 'field',
      id: 'currency'
    }, {
      type: 'text',
      id: 'constrainedNumericFieldsHeader'
    }, {
      type: 'field',
      id: 'numberConstrained1'
    }, {
      type: 'field',
      id: 'numberConstrained2'
    }, {
      type: 'field',
      id: 'numberConstrained3'
    }, {
      type: 'field',
      id: 'doubleConstrained'
    }, {
      type: 'field',
      id: 'percentConstrained'
    }, {
      type: 'field',
      id: 'currencyConstrained'
    }, {
      type: 'text',
      id: 'restrictedNumericFieldsHeader'
    }, {
      type: 'field',
      id: 'percentReadOnly'
    }, {
      type: 'field',
      id: 'percentDisabled'
    }, {
      type: 'field',
      id: 'currencyReadOnly'
    }, {
      type: 'field',
      id: 'currencyDisabled'
    }, {
      type: 'text',
      id: 'suppressFormatNumericFieldsHeader'
    }, {
      type: 'field',
      id: 'numberSuppressFormatting'
    }, {
      type: 'field',
      id: 'doubleSuppressFormatting'
    }, {
      type: 'array',
      id: 'arrayWithDecoratedFields'
    }]
  },
  formData: {
    number: 100,
    numberConstrained1: 'text',
    percentReadOnly: 90,
    percentDisabled: 50,
    currencyReadOnly: 987654.321,
    currencyDisabled: 123456.789
  }
};